const css = `.cnzRhG__light th{background-color:var(--base-surfaces-default)}.cnzRhG__dark th{background-color:var(--_overrides-table-surfaces-secondary)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"light":"cnzRhG__light","dark":"cnzRhG__dark"};
